import Button from 'components/Button/Button';
import { AIOptionSelector } from './AIOptionSelector';
import "./AIGeneratorForm.css"
import { t } from 'i18next';

export const AIGeneratorForm = ({
    title,
    onGenerate,
    onOptionChange,
    toneOptions,
    sizeOptions,
    langOptions,
    disabled,
    className,
    options,
    warningMessage
}) => {
    return (
        <div className={disabled ? `component-disabled ${className}` : `${className}`} >
            <div className='title-form'>{title}</div>
            <div className='content-ai-selector'>
                <div className="ai-options-container">
                    {toneOptions && (
                        <div className='d-flex'>
                            <div>{t("AI.Tone")}</div>
                            <AIOptionSelector
                                options={toneOptions}
                                value={options.tone}
                                onChange={(value) => onOptionChange('tone', value)}
                            />
                        </div>
                    )}

                    {sizeOptions && (
                        <div className='d-flex'>
                            <div>{t("AI.Format")}</div>
                            <AIOptionSelector
                                options={sizeOptions}
                                value={options.size}
                                onChange={(value) => onOptionChange('size', value)}
                            />
                        </div>
                    )}

                    {langOptions && (
                        <div className='d-flex'>
                            <div>{t("AI.Language")}</div>
                            <AIOptionSelector
                                options={langOptions}
                                value={options.lang}
                                onChange={(value) => onOptionChange('lang', value)}
                            />
                        </div>
                    )}
                </div>
                {warningMessage && <p className='info'>{warningMessage}</p>}
                <Button className="btn btn-blue me-2" onClick={onGenerate} disabled={disabled}>
                    {t("AI.BtnText")}
                </Button>

            </div>

        </div>
    );
};